<template>
  <div class="columns">
    <div class="column">
      <img src="@/assets/FirmaFRS.jpg" alt="logoSietV" />
    </div>
    <div v-if="logo" class="column is-1 m-auto">
      <div class="divider">&nbsp;</div>
    </div>
    <div v-if="logo" class="content-img column">
      <img src="@/assets/logoVertical.png" alt="logoSietV" />
    </div>
  </div>
</template>

<script>
// import domtoimage from "dom-to-image-more";

export default {
  props: {
    img: {
      type: Boolean,
      default() {
        return false;
      },
    },
    logo: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  mounted() {
    /* const filter = (node) => {
      // Ignorar hojas de estilo externas y enlaces de fuentes
      return !(
        node instanceof HTMLLinkElement &&
        node.href.includes("fonts.googleapis.com")
      );
    };
    this.$nextTick(() => {
      if (this.img) {
        const element = document.getElementById("content-cards-professional");

        domtoimage
          .toPng(element, {
            filter: filter,
          })
          .then(function(dataUrl) {
            const img = new Image();
            img.src = dataUrl;
            element.innerHTML = "";
            element.appendChild(img);
          })
          .catch(function(error) {
            console.error("Error generating image:", error);
          });
      }
    }); */
  },
  methods: {
    dateToString(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
  },
};
</script>
<style lang="scss" scoped>
h3 {
  margin: 2px;
  font-weight: unset;
}
.content-img {
  display: flex;
  justify-content: center;
}
.content-img > img {
  height: 300px;
}
.m-auto {
  margin: auto;
}
.divider {
  margin: auto;
  text-align: center;
  height: 300px;
  width: 0.25rem;
  background: linear-gradient(to bottom, #d27ff9, #a84ff7, #9246df, #9641cc);
}

#content-cards-professional {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/components/frp/CardProfessional.vue